import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import "./consentBottomSheet.css";

const ConsentBottomSheet = ({ show, onAgree, onRemind, isLoading }) => {
  const [isChecked, setIsChecked] = useState(false);
  const [showAnimation, setShowAnimation] = useState(false);

  // Handle animation timing
  useEffect(() => {
    if (show) {
      // Small delay to ensure DOM is ready for the animation
      setTimeout(() => setShowAnimation(true), 50);
    } else {
      setShowAnimation(false);
    }
  }, [show]);

  // Reset checkbox when the sheet closes and reopens
  useEffect(() => {
    if (!show) {
      setIsChecked(false);
    }
  }, [show]);

  const handleCheckboxChange = (e) => {
    setIsChecked(e.target.checked);
  };

  return (
    <div className={`bottom-sheet-container ${show ? "show" : ""}`}>
      <Modal
        show={show}
        backdrop="static"
        keyboard={false}
        dialogClassName="consent-bottom-sheet"
        contentClassName="consent-bottom-content"
        className={`consent-bottom-sheet ${showAnimation ? "show" : ""}`}
      >
        <Modal.Body>
          <div className="permission-consent">
            <h4>Welcome to Your Inspection Report</h4>
            <p>
              This inspection report is hosted on Morph's secure platform. To
              support report delivery and provide you with valuable home
              protection and maintenance recommendations, we may share report
              contents with trusted 3rd party services.
            </p>
            <p>
              By proceeding, you confirm ownership of this property and consent
              to the data practices outlined in our:
            </p>
            <div className="links">
              <a
                href="https://www.morph-technologies.com/terms-conditions"
                target="_blank"
                rel="noopener noreferrer"
              >
                Terms and Conditions
              </a>
              <a
                href="https://www.morph-technologies.com/privacy-policy"
                target="_blank"
                rel="noopener noreferrer"
              >
                Privacy Policy
              </a>
            </div>
            <div className="checkbox-container">
              <input
                type="checkbox"
                id="consent-checkbox"
                checked={isChecked}
                onChange={handleCheckboxChange}
              />
              <label htmlFor="consent-checkbox">
                I confirm I'm the property owner and agree to the Terms &
                Privacy Policy.
              </label>
            </div>
            <div className="button-group">
              <button
                className="agree-btn"
                onClick={() => onAgree(isChecked)}
                disabled={isLoading || !isChecked}
              >
                View My Report
              </button>
              <button
                className="remind-btn"
                onClick={onRemind}
                disabled={isLoading}
              >
                Remind Me Later
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ConsentBottomSheet;
